/* ==========================================================================
   PAWTHRILL - GALERIE PRODUIT FACON IKEA
   Charge par snippets/pt-gallery.liquid, depuis le modele produit par defaut
   (templates/product.json).

   Deux ajouts a la galerie native de Dawn, sans la remplacer :
   1. des fleches precedent / suivant sur l'image principale ;
   2. la vignette active gardee visible dans le rail vertical.

   Les fleches ne changent pas l'image elles-memes : elles cliquent la vignette
   voisine. C'est Dawn (assets/media-gallery.js) qui fait le reste, exactement
   comme si le visiteur avait clique la vignette : image active, video, modele
   3D, zoom et annonce pour les lecteurs d'ecran restent geres au meme endroit.

   Dawn re-rend toute la section produit quand on change de variante. Les
   galeries sont donc detectees a chaque modification du DOM plutot qu'une
   seule fois au chargement, et chacune n'est equipee qu'une fois.
   ========================================================================== */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function thumbnailsOf(gallery) {
    return gallery.querySelector('[id^="GalleryThumbnails"]');
  }

  /* Vignettes reellement affichees. Avec « masquer les medias des autres
     variantes », Dawn cache certaines vignettes au lieu de les retirer : les
     fleches doivent les sauter. */
  function visibleItems(thumbnails) {
    return Array.prototype.filter.call(thumbnails.querySelectorAll('[data-target]'), function (item) {
      return item.offsetParent !== null;
    });
  }

  function activeIndex(items) {
    for (var i = 0; i < items.length; i++) {
      var button = items[i].querySelector('button');
      if (button && button.getAttribute('aria-current') === 'true') return i;
    }
    return 0;
  }

  /* Dawn ramene la vignette active en vue par un defilement horizontal. Dans
     le rail vertical, ce defilement ne fait rien : on le fait ici, dans le rail
     seulement, pour ne jamais faire bouger la page. */
  function revealActive(thumbnails) {
    var list = thumbnails.querySelector('.thumbnail-list');
    if (!list || list.scrollHeight <= list.clientHeight) return;
    var items = visibleItems(thumbnails);
    var item = items[activeIndex(items)];
    if (!item) return;
    var top = item.offsetTop - (list.clientHeight - item.offsetHeight) / 2;
    list.scrollTo({ top: Math.max(0, top), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
  }

  function update(gallery, nav) {
    var thumbnails = thumbnailsOf(gallery);
    if (!thumbnails) return;
    var items = visibleItems(thumbnails);
    var index = activeIndex(items);
    nav.hidden = items.length < 2;
    nav.querySelector('[data-dir="-1"]').disabled = index <= 0;
    nav.querySelector('[data-dir="1"]').disabled = index >= items.length - 1;
    revealActive(thumbnails);
  }

  function step(gallery, direction) {
    var thumbnails = thumbnailsOf(gallery);
    if (!thumbnails) return;
    var items = visibleItems(thumbnails);
    var target = items[activeIndex(items) + direction];
    var button = target && target.querySelector('button');
    if (button) button.click();
  }

  function equip(gallery) {
    if (gallery.dataset.ptGallery === 'true') return;
    if ((gallery.dataset.desktopLayout || '').indexOf('thumbnail') === -1) return;
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    var thumbnails = thumbnailsOf(gallery);
    var template = document.getElementById('pt-gallery-nav');
    if (!viewer || !thumbnails || !template) return;

    gallery.dataset.ptGallery = 'true';
    var nav = template.content.firstElementChild.cloneNode(true);
    nav.querySelectorAll('button').forEach(function (button) {
      button.setAttribute('aria-controls', viewer.id);
    });
    viewer.appendChild(nav);

    nav.addEventListener('click', function (event) {
      var button = event.target.closest('button[data-dir]');
      if (button) step(gallery, Number(button.dataset.dir));
    });

    new MutationObserver(function () {
      update(gallery, nav);
    }).observe(thumbnails, { attributes: true, subtree: true, attributeFilter: ['aria-current'] });

    update(gallery, nav);
  }

  function scan() {
    document.querySelectorAll('media-gallery').forEach(equip);
  }

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      scan();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
